var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbed-links"},[_c('router-link',{attrs:{"to":"/my-library"}},[_c('div',{staticClass:"el-button is-active el-button--text"},[_c('span',[_vm._v("My Library")])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/library"}},[_c('div',{staticClass:"el-button el-button--text"},[_c('span',[_vm._v("Coobo library")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283e9ea5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabbed-links.vue
// module id = null
// module chunks = 